<!--
  This example requires Tailwind CSS v2.0+

  This example requires some changes to your config:

  ```
  // tailwind.config.js
  const colors = require('tailwindcss/colors')

  module.exports = {
    // ...
    theme: {
      extend: {
        colors: {
          'light-blue': colors.lightBlue,
          teal: colors.teal,
          rose: colors.rose,
        }
      }
    }
  }
  ```
-->
<template>
    <app-layout>
        <template #header>
            <FarmTitle>
                Start
            </FarmTitle>
        </template>

        <div class="py-12">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg">
    <div class="rounded-lg bg-gray-200 overflow-hidden shadow divide-y divide-gray-200 sm:divide-y-0 sm:grid sm:grid-cols-2 sm:gap-px">
        <div v-for="(action, actionIdx) in actions" :key="action.title" :class="[actionIdx === 0 ? 'rounded-tl-lg rounded-tr-lg sm:rounded-tr-none' : '', actionIdx === 1 ? 'sm:rounded-tr-lg' : '', actionIdx === actions.length - 2 ? 'sm:rounded-bl-lg' : '', actionIdx === actions.length - 1 ? 'rounded-bl-lg rounded-br-lg sm:rounded-bl-none' : '', 'relative group bg-white p-6 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-500']">
            <div>
        <span :class="[action.iconBackground, action.iconForeground, 'rounded-lg inline-flex p-3 ring-4 ring-white']">
          <component :is="action.icon" class="h-6 w-6" aria-hidden="true" />
        </span>
            </div>
            <div class="mt-8">
                <h3 class="text-lg font-medium">
                    <inertia-link :href="action.href" class="focus:outline-none">
                        <!-- Extend touch target to entire panel -->
                        <span class="absolute inset-0" aria-hidden="true" />
                        {{ action.title }}
                    </inertia-link>
                </h3>
                <p class="mt-2 text-sm text-gray-500">
                    {{ action.desc }}
                </p>
            </div>
            <span class="pointer-events-none absolute top-6 right-6 text-gray-300 group-hover:text-gray-400" aria-hidden="true">
        <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
          <path d="M20 4h1a1 1 0 00-1-1v1zm-1 12a1 1 0 102 0h-2zM8 3a1 1 0 000 2V3zM3.293 19.293a1 1 0 101.414 1.414l-1.414-1.414zM19 4v12h2V4h-2zm1-1H8v2h12V3zm-.707.293l-16 16 1.414 1.414 16-16-1.414-1.414z" />
        </svg>
      </span>
        </div>
    </div>
                </div></div>
        </div>
    </app-layout>
</template>

<script>
import {
    AcademicCapIcon,
    BadgeCheckIcon,
    CashIcon,
    ClockIcon,
    ReceiptRefundIcon,
    UsersIcon,
    MailIcon,
    OfficeBuildingIcon,
    ViewListIcon,
    UploadIcon,
    CreditCardIcon,
    ShoppingCartIcon,
    TableIcon
} from '@heroicons/vue/solid'
import AppLayout from "@/Layouts/AppLayout";
import FarmTitle from "@/Layouts/FarmTitle";

const actions = [
    {
        title: 'Pferde',
        desc: 'Pferde einsehen',
        href: route('horses.index'),
        icon: TableIcon,
        iconForeground: 'text-green-700',
        iconBackground: 'bg-green-100',
    },
    {
        title: 'Produkte',
        desc: 'Produkte und Preise einsehen und bearbeiten',
        href: route('products.index'),
        icon: ShoppingCartIcon,
        iconForeground: 'text-yellow-700',
        iconBackground: 'bg-yellow-100',
    },
    {
        title: 'Kunden',
        desc: 'Kunden verwalten',
        href: route('customers.index'),
        icon: UsersIcon,
        iconForeground: 'text-pink-700',
        iconBackground: 'bg-pink-100',
    },
    {
        title: 'Newsletter',
        desc: 'Newsletter versenden, oder Abonennten verwalten',
        href: route('email.index'),
        icon: MailIcon,
        iconForeground: 'text-gray-700',
        iconBackground: 'bg-gray-100',
    },
    {
        title: 'SEPA',
        desc: 'SEPA-Mandate einsehen, erstellen und löschen',
        href: route('sepa.index'),
        icon: CreditCardIcon,
        iconForeground: 'text-indigo-700',
        iconBackground: 'bg-indigo-100',
    },
    {
        title: 'Exportpunkt erstellen',
        desc: 'Exportpunkt erstellen',
        href: route('exports.index'),
        icon: UploadIcon,
        iconForeground: 'text-red-700',
        iconBackground: 'bg-red-100',
    }
]

export default {
    title: 'Start',
    components: {
        FarmTitle,
        AppLayout,
    },
    setup() {
        return {
            actions,
        }
    },
}
</script>

